/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "新增"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "全部移除"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var zhTW = Object.assign(TranslationProviderComponent, {
  translations
});

export { zhTW as z };
//# sourceMappingURL=zh-TW-DVSfHBRV.js.map
